import { singleUploadService } from 'api/singleUpload';
import { RootObject } from 'componentsV2/AssestUpload/SingleUpload/SingleUploadModel';
import {
  SINGLE_UPLOAD_PAYLOAD_CLEAR,
  SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS
} from 'constants/actionTypes';

export const singleUploadActions = {
  updateSingleUploadPayload,
  clearSingleUploadPayload,
  fetchDropdownValues,
  pubmedIdValidation
};

// Action to update the single upload payload
function updateSingleUploadPayload(data: RootObject) {
  return (dispatch: any) => {
    dispatch(updateSingleUploadPayloadSuccess(data));
  };
}


function clearSingleUploadPayload() {
  return {
    type: SINGLE_UPLOAD_PAYLOAD_CLEAR,
    payload: null
  };
}

// Action creator for successful payload update
function updateSingleUploadPayloadSuccess(data: RootObject) {
  return {
    type: SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS,
    payload: data
  };
}

// Dropdown api call
async function fetchDropdownValues(id: string) {
  try {
    const response = await singleUploadService
      .fetchDropdownValues(id)
      .then((result: any) => result.json());
    return response;
  } catch (error) {
    return {
      message: error?.toString()
    };
  }
}

//pubmed id on blur validation
async function pubmedIdValidation(id: string) {
  try {
    const response = await singleUploadService
      .pubmedIdValidation(id)
      .then((result: any) => result.json());
    return response;
  } catch (error) {
    return {
      message: error?.toString()
    };
  }
}
